<template>
    <div class="card">
        <header class="card-header">
            <router-link to="/cars/" class="card-header-title">
                Vessel Arrived due Date
            </router-link>
            <router-link to="/cars/" class="card-header-icon" aria-label="more options">
                  <span class="icon has-text-danger">
                      <i class="fas fa-ship"></i>
                  </span>
            </router-link>
        </header>
        <div class="card-content">
            <chart :type="'line'" :data="data" :options="options"></chart>
        </div>
    </div>
</template>

<script>
    import Chart from 'vue-bulma-chartjs'

    export default {
        components: {
            Chart
        },

        data () {
            return {
                data: {
                    labels: ['January', 'February', 'March', 'April', 'May'],
                    datasets: [{
                        data: [0],
                        label: "Late",
                        borderColor: "#ff3860",
                        fill: false
                    }]
                },
                options: {
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    beginAtZero: true
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .card {
        height: 255px;
    }
    .card-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .total {
        font-size: 5rem;
        font-weight: 600;
    }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager/VesselArrivedDue.vue